export const APP_PORTAL_ROOT_ID = "app-portal-root";

export function getAppPortalRoot() {
  if (typeof document === "undefined") return null;
  return document.getElementById(APP_PORTAL_ROOT_ID) || document.body;
}
